var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'dark')?_c('icon-logo'):(_vm.type === 'dark-stacked')?_c('img',{attrs:{"src":require("@/assets/logo/logo-stacked.png"),"alt":"Budd"}}):_c('icon-logo-white')}
var staticRenderFns = []

export { render, staticRenderFns }